import { render, staticRenderFns } from "./PoolMessageFromTalentNotificationListItem.vue?vue&type=template&id=042d3111&scoped=true&"
import script from "./PoolMessageFromTalentNotificationListItem.vue?vue&type=script&lang=ts&"
export * from "./PoolMessageFromTalentNotificationListItem.vue?vue&type=script&lang=ts&"
import style0 from "./PoolMessageFromTalentNotificationListItem.vue?vue&type=style&index=0&id=042d3111&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042d3111",
  null
  
)

/* custom blocks */
import block0 from "./PoolMessageFromTalentNotificationListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports